import Icon from 'vue-awesome/components/Icon.vue';
Icon.register({
  respotSimple: {
    width: 100,
    height: 100,
    d: `M50,2.507C23.77,2.507,2.507,23.77,2.507,50S23.77,97.493,50,97.493S97.493,76.23,97.493,50
  		S76.23,2.507,50,2.507z M83.569,51.351L70.622,63.081c-1.172,1.062-3.047,0.23-3.047-1.351v-7.357H32.425v7.357
  		c0,1.581-1.876,2.413-3.047,1.351L16.431,51.351c-0.799-0.724-0.799-1.979,0-2.702L29.378,36.92
  		c1.172-1.062,3.047-0.23,3.047,1.351v7.357h35.149v-7.357c0-1.581,1.875-2.413,3.047-1.351l12.947,11.729
  		C84.367,49.372,84.367,50.627,83.569,51.351z`,
  },
});
